import { useEffect, type ReactNode } from "react";
import { MotionConfig } from "motion/react";
import type { ProductCode } from "@fd/tokens";

export type Theme = "light" | "dark";

export interface FDProviderProps {
  theme?: Theme;
  /** Optional product surface — sets data-product on <html> for product-accent theming. */
  product?: ProductCode;
  children: ReactNode;
}

export function FDProvider({ theme = "light", product, children }: FDProviderProps) {
  useEffect(() => {
    if (typeof document === "undefined") return;
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);
  useEffect(() => {
    if (typeof document === "undefined") return;
    if (product) document.documentElement.setAttribute("data-product", product);
    else document.documentElement.removeAttribute("data-product");
  }, [product]);
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
